import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useMediaQuery,
  useTheme,
  Typography,
  Box,
} from "@mui/material";
import { FaFileExcel } from "react-icons/fa";
import * as XLSX from "xlsx";
import { useState } from "react";
import { toolbarButtonSx } from "../auth/authTheme";

const ExportButton = ({
  gridRef,
  fileName = "export.xlsx",
  exportColumns = [],
  disabled,
  onSelectionCleared,
}) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [exportCount, setExportCount] = useState(0);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleExport = () => {
    const api = gridRef?.current;
    if (!api) return;

    const selectedRows = api.getSelectedRows();
    if (selectedRows.length === 0) {
      alert("Please select rows to export.");
      return;
    }

    setExportCount(selectedRows.length);

    const filteredRows = selectedRows.map((row) => {
      const filtered = {};
      exportColumns.forEach((key) => {
        filtered[key] = row[key];
      });
      return filtered;
    });

    const worksheet = XLSX.utils.json_to_sheet(filteredRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    XLSX.writeFile(workbook, fileName);

    const handleFocus = () => {
      setOpenDialog(true);
      window.removeEventListener("focus", handleFocus);
    };
    window.addEventListener("focus", handleFocus);
  };

  const handleClearSelection = () => {
    const api = gridRef?.current;
    if (api?.deselectAll) {
      api.deselectAll();
    }
    onSelectionCleared?.();
    setOpenDialog(false);
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={handleExport}
        disabled={disabled}
        startIcon={<FaFileExcel />}
        sx={toolbarButtonSx}
      >
        Export Selected
      </Button>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        fullScreen={fullScreen}
      >
        <DialogTitle>
          <Typography variant="h6" component="div" sx={{ fontWeight: 700 }}>
            Export complete
          </Typography>
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            You have successfully exported <strong>{exportCount}</strong> row
            {exportCount > 1 ? "s" : ""}. Would you like to clear the current
            selection?
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Box display="flex" justifyContent="space-between" width="100%">
            <Button
              onClick={() => setOpenDialog(false)}
              variant="outlined"
              color="inherit"
            >
              Keep selection
            </Button>
            <Button
              onClick={handleClearSelection}
              variant="contained"
              color="success"
            >
              Clear selection
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ExportButton;
